import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/customer-operation',
  component: Layout,
  name: 'CustomerOperation',
  meta: {
    title: '客户运营',
    icon: 'i-ant-design:bank-outlined',
    auth: 'customer:list',
  },
  children: [
    {
      path: '/customer/index',
      name: 'CustomerIndex',
      component: () => import('@/views/customer/index.vue'),
      meta: {
        title: '客户管理',
        icon: 'i-ant-design:team-outlined',
        auth: 'customer:list',
      },
    },
  ],
}

export default routes
